import React from "react";

export default ({ direction = "down" }) => (
  <i className={`css-arrow-${direction}`}>
    <span />
    <span />
    <span />
  </i>
);
